import React from 'react';
import { playButton } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Webcam',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'webcam',
  icon: {
    baseShape: playButton,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 35,
  },
  standardMarkerOptions: {
    markerType: 'webcamMarker',
    allowCreation: false,
    allowEditing: false,
    allowComments: false,
    viewOptions: {
      typeTitle: 'Webcam',
      itemTitleFunction: (item) => (item && item.title) || 'Webcam',
    },
    creationOptions: {
      menuText: '',
      newTitle: '',
      titlePlaceholder: 'Title',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a webcam location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: false,
    displayUpVotes: false,
    title: 'Webcam',
    description:
      'See the current conditions from a publicly available video feed',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

// layer.onMapClickEvent = showPopOverFromEvent(layer);

export default layer;
